/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coaching_Template_ItemsInputs */

const en_us2_coaching_template_items = /** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercises: ${i?.count}`)
};

const pt_br2_coaching_template_items = /** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercícios: ${i?.count}`)
};

const pt_pt2_coaching_template_items = /** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exercícios: ${i?.count}`)
};

/** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */
const es_419_coaching_template_items = en_us2_coaching_template_items;

/** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */
const fr_fr2_coaching_template_items = en_us2_coaching_template_items;

/** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */
const de_de2_coaching_template_items = en_us2_coaching_template_items;

/** @type {(inputs: Coaching_Template_ItemsInputs) => LocalizedString} */
const it_it2_coaching_template_items = en_us2_coaching_template_items;

/**
* | output |
* | --- |
* | "Exercises: {count}" |
*
* @param {Coaching_Template_ItemsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_template_items = /** @type {((inputs: Coaching_Template_ItemsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Template_ItemsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_template_items(inputs)
	if (locale === "es-419") return es_419_coaching_template_items(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_template_items(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_template_items(inputs)
	if (locale === "de-DE") return de_de2_coaching_template_items(inputs)
	if (locale === "it-IT") return it_it2_coaching_template_items(inputs)
	return en_us2_coaching_template_items(inputs)
});
export { coaching_template_items as "coaching.template_items" }